import "./index.less";

import { useSelector } from "react-redux";
import { TStoreData } from "../../interface";

export function MicroappView() {
  const storeData = useSelector((data: TStoreData) => {
    return {
      subMenuList: data?.subMenuList || [],
      layoutMode: data?.layoutMode,
    };
  });
  const { layoutMode, subMenuList } = storeData;
  const isSr = layoutMode === "sr";
  const hasSubMenu = subMenuList.length > 0;

  return (
    <div
      id="micro-container"
    ></div>
  );
}

export default MicroappView;
